import { trim } from 'lib/helpers';

export function isNoResultsPage() { /* eslint-disable-line import/prefer-default-export */
  const searchResultsWrap = document.querySelector('[data-target="search-results-main-wrap"]');
  return searchResultsWrap.getAttribute('data-no-results');
}

export function sanitizeTerm(term) {
  return trim(term).toLowerCase().replace(/[^a-zA-Z0-9 ]/g, '');
}
